"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanReadableDateTimeFormat = exports.humanReadableTimeFormat = exports.humanReadableDateFormat = exports.sqlDateFormat = exports.reDateRange = exports.reISO8601 = void 0;
const year = "([12][0-9]{3})";
const month = "(0[1-9]|1[0-2])";
const day = "([12][0-9]|0[1-9]|3[01])";
const hour = "([01][0-9]|2[0-3])";
const minute = "([0-5][0-9])";
const second = "([0-5][0-9])";
const milli = "([0-9]{3})";
const ISO8601 = `${year}-${month}-${day}T${hour}:${minute}:${second}.${milli}Z`;
exports.reISO8601 = new RegExp(`^${ISO8601}$`);
exports.reDateRange = new RegExp(`^${ISO8601}\\/${ISO8601}$`);
exports.sqlDateFormat = "yyyy-MM-dd";
exports.humanReadableDateFormat = "yyyy MMM dd";
exports.humanReadableTimeFormat = "HH:mm";
exports.humanReadableDateTimeFormat = `${exports.humanReadableDateFormat} ${exports.humanReadableTimeFormat}`;
//# sourceMappingURL=date.js.map